import React, { useEffect, useRef, useState, useContext } from 'react'
import './Ratibjmasabh.css'
import back from "../../imgs/backexam.png";
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { UilEditAlt, UilTrash, UilSetting } from '@iconscout/react-unicons'
import { useLocation, useNavigate } from "react-router-dom";
import Globalcontext from '../../Context/Globalcontext';
import { useTranslation } from "react-i18next";

const Ratibjmasabh = (props) => {
    const { t } = useTranslation();

    const inputRefs = useRef([]);
    const [newedit, setNewedit] = useState("new");
    const [input, setInput] = useState({ date: new Date().toISOString().substr(0, 10), kno: "", name: "", type: "", amt: "", remark: "-" });
    const { submenu, setsubmenu, newcustsource, setNewcustsource, custlist, setCustlist } = useContext(Globalcontext);
    const [DataSource, setDataSource] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [khnames, setKhnames] = useState([]);
    const [value, setValue] = useState('');
    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [stock, setStock] = useState();
    const [sredit, setSredit] = useState('');
    const [mastermenu, setMastermenu] = useState(true);
    const [kopen, setkopen] = useState(0);
    const { sanksource, setSanksource, setHeadname } = useContext(Globalcontext);
    const [transitionEnded, setTransitionEnded] = useState(true);

    function handleEnterKey(event, currentIndex) {

        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = null;
            nextIndex = currentIndex + 1;
            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }
        if (event.key === 'Backspace' && (
            (event.target.tagName === 'INPUT' && event.target.value === '') ||
            (event.target.tagName === 'SELECT' && (
                (event.target.name === 'type' && event.target.value === t("Ratibjmasabh.select.credit"))
            ))
        )) {
            event.preventDefault();

            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0) {
                const prevElement = inputRefs.current[prevIndex];
                if (prevElement) {
                    if (
                        (prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') &&
                        prevElement !== event.target
                    ) {
                        prevElement.focus();
                        break;
                    } else {
                        prevIndex--;
                    }
                } else {
                    prevIndex--;
                }
            }
        }
    }

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));
    }

    useEffect(() => {

        if (input.kno === "") {
            setInput(prevInput => ({
                ...prevInput,
                kno: "",
                name: "",
                type: "",
                amt: "",
                remark: "",
            }))
            setNewedit("new");
        }
        else {
            let custlisttemp = JSON.parse(localStorage.getItem("custlist"));
            for (let i = 0; i < custlisttemp.length; i++) {
                setInput(prevInput => ({
                    ...prevInput,
                    name: ''
                }));
                const user = custlisttemp[i];
                if (user.kno === input.kno) {
                    setInput(prevInput => ({
                        ...prevInput,
                        name: user.cname
                    }));
                    break;
                }
            }
        }
    }, [input.kno])

    async function getratibcustomer() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        props.setProgress(30);
        setTimeout(() => {
            props.setProgress(50);
        }, 200);
        axios.post('https://excellentdairy.com/dairy/php/cust/getratibcustomer.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                localStorage.setItem("sanghlist", JSON.stringify(response.data));
            }
        }).catch(err => {
            console.log(err);
        });
    }

    async function getcustdata(kno) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        setTimeout(() => {
            props.setProgress(70);
        }, 200);
        axios.post('https://excellentdairy.com/dairy/php/cust/getcustomer.php', { kno: kno, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {

            if (response.data.length > 0) {
                response.data.map((user, index) =>
                (
                    setInput(prevInput => ({
                        ...prevInput,
                        name: user.cname,
                    }))
                )
                )
            }
            setTimeout(() => {
                props.setProgress(100);
            }, 200);
        }).catch(err => {
            console.log(err);
        });
    }

    function handleEnterKeybutton(event, currentIndex) {
        if (event.key === 'Enter') {
            event.preventDefault();
            saveratibjma();
            let nextIndex = null;
            if (currentIndex === 0) {
                if (input.name !== "") {
                    nextIndex = currentIndex + 1;
                }
                else {
                    nextIndex = currentIndex;
                }
            }
            else {
                nextIndex = currentIndex + 1;
            }
            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }
        else if (event.key === "Backspace") {
            if (event.target.tagName === "BUTTON") {
                if (inputRefs.current[4]) {
                    inputRefs.current[4].focus();
                }
            }
        }
    }

    const saveratibjma = () => {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        if (input.date === "" || input.kno === "" || input.name === "" || input.amt === "" || input.remark === "") {
            notifyerror(t("Ratibjmasabh.toast.incompleteEntry"));
            return;
        }
        let rawData = {
            date: input.date,
            kno: input.kno,
            type: input.type,
            amt: input.amt,
            remark: input.remark,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            flag: newedit,
            sredit: sredit,
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        formData.append('data', rawData)

        axios.post('https://excellentdairy.com/dairy/php/cust/saveratibjmasabh.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {
            if (newedit === "new") {
                if (response.data.trim() === "Saved.") {
                    notify(t("Ratibjmasabh.toast.saved"));
                }
            }
            else {
                if (response.data.trim() === "updated.") {
                    notify(t("Ratibjmasabh.toast.updated"));
                }
            }

            setInput(prevInput => ({
                ...prevInput,
                kno: "",
                type: "",
                amt: "",
                remark: "",
            }))
            setSredit("");
            setNewedit("new");
            getratibjma();
            if (inputRefs.current[1]) {
                inputRefs.current[1].focus();
            }
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        getratibjma();
        if (inputRefs.current[1]) {
            inputRefs.current[1].focus();
        }
    }, [])

    async function getratibjma() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getratibjmasabh.php', { date: input.date, time: input.time, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                setDataSource(response.data);
                setTimeout(() => {
                    props.setProgress(100);
                }, 200);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const handleedit = (sr, date, rno, amt, remark) => {
        setInput({ sr: sr, date: date, kno: rno, amt: amt, remark: remark })
        setNewedit("edit");
        setSredit(sr);
    }

    async function deleteratibjma(sr) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/deleteratibjma.php', { sr: sr, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                notify(response.data);
                setInput(prevInput => ({
                    ...prevInput,
                    kno: "",
                    name: "",
                    type: "",
                    amt: "",
                }))
                setSredit("");
                setNewedit("new");
                getratibjma();
                if (inputRefs.current[1]) {
                    inputRefs.current[1].focus();
                }
            }
        }).catch(err => {
            console.log(err);
        });
    }

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    const openratibvikri = (flag) => {
        setsubmenu("Ratibsabh");
        setHeadname(t("Ratibjmasabh.head.ratibSaleMember"));
    };

    const visibility = () => {
        localStorage.setItem("glcustsr", "");
        setTransitionEnded(false);
        setMastermenu(!mastermenu);
        setkopen(0);
        setsubmenu("");
        setHeadname(t("Ratibjmasabh.head.dailyTransactions"));
    }

    return (
        <div className="khadyamain">
            <div className="firstrowkhadya">
                <img onClick={openratibvikri} className='back' src={back} alt="" />
                <div className="colmainkhadya">
                    <div className="firstrow2">
                        <div className="rowsank">
                            <div className="mb-2">
                                <span className='subheadsank'>{t("Ratibjmasabh.labels.date")}</span>
                                <input
                                    onKeyDown={e => handleEnterKey(e, 0)}
                                    ref={ref => (inputRefs.current[0] = ref)}
                                    type="date"
                                    className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                                    autoComplete='off'
                                    id="date"
                                    name="date"
                                    value={input.date}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='linekh' />

            <div className="row1ratibjma">
                <div className="mb-2">
                    <span className='subheadsank'>{t("Ratibjmasabh.labels.accountNo")}</span>
                    <input
                        onKeyDown={e => handleEnterKey(e, 1)}
                        ref={ref => (inputRefs.current[1] = ref)}
                        type="number"
                        className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
                        autoComplete='off'
                        id="kno"
                        name="kno"
                        value={input.kno}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2">
                    <span className='subheadsank'>{t("Ratibjmasabh.labels.ratibCustomerName")}</span>
                    <input
                        type="text"
                        disabled
                        className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                        autoComplete='off'
                        id="name"
                        name="name"
                        value={input.name}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className='linekh' />

            <div className="row1ratibjma">
                <div className="mb-2">
                    <span className='subheadsank'>{t("Ratibjmasabh.labels.type")}</span>
                    <select
                        onKeyDown={e => handleEnterKey(e, 2)}
                        ref={ref => (inputRefs.current[2] = ref)}
                        value={input.type}
                        name='type'
                        id='type'
                        onChange={handleChange}
                        className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                    >
                        <option value="Credit">{t("Ratibjmasabh.select.credit")}</option>
                    </select>
                </div>

                <div className="mb-2">
                    <span className='subheadsank'>{t("Ratibjmasabh.labels.amount")}</span>
                    <input
                        onKeyDown={e => handleEnterKey(e, 3)}
                        ref={ref => (inputRefs.current[3] = ref)}
                        type="number"
                        className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
                        autoComplete='off'
                        id="amt"
                        name="amt"
                        value={input.amt}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2">
                    <span className='subheadsank'>{t("Ratibjmasabh.labels.remark")}</span>
                    <input
                        type="text"
                        onKeyDown={e => handleEnterKey(e, 4)}
                        ref={ref => (inputRefs.current[4] = ref)}
                        className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                        autoComplete='off'
                        id="remark"
                        name="remark"
                        value={input.remark}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="row1kh">
                <div className="mb-2">
                    <button
                        onClick={saveratibjma}
                        onKeyDown={e => handleEnterKeybutton(e, 0)}
                        ref={ref => (inputRefs.current[5] = ref)}
                        type="submit"
                        className="btn btn-primary mx-1 sanksmall"
                    >
                        {newedit === "new" ? t("Ratibjmasabh.buttons.save") : t("Ratibjmasabh.buttons.update")}
                    </button>

                    <button type="submit" className="btn btn-primary mx-1 sanksmall">
                        {t("Ratibjmasabh.buttons.report")}
                    </button>
                </div>
            </div>

            <div className="firstrow2">
                <div className="table-containeruchal">
                    <table id="myTable" className="table table-bordered">
                        <thead>
                            <tr>
                                <th className='thsmall' scope="col">{t("Ratibjmasabh.table.sr")}</th>
                                <th className='thsmall' scope="col">{t("Ratibjmasabh.table.date")}</th>
                                <th className='thsmall' scope="col">{t("Ratibjmasabh.table.accountNoShort")}</th>
                                <th className='thsmall' scope="col">{t("Ratibjmasabh.table.name")}</th>
                                <th className='thsmall' scope="col">{t("Ratibjmasabh.table.amount")}</th>
                                <th className='thsmall' scope="col">{t("Ratibjmasabh.table.action")}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {value.length > 0
                                ? tableFilter.map((user, index) =>
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{user.date}</td>
                                        <td>{user.rno}</td>
                                        <td>{user.name}</td>
                                        <td>{user.amt}</td>
                                    </tr>
                                )
                                : DataSource.map((user, index) =>
                                    <tr key={index}>
                                        <td className='thsmall'>{index + 1}</td>
                                        <td className='thsmall'>{user.date}</td>
                                        <td className='thsmall'>{user.rno}</td>
                                        <td className='thsmall'>{user.name}</td>
                                        <td className='thsmall2'>{user.amt}</td>
                                        <td>
                                            <UilEditAlt onClick={() => { handleedit(user.sr, user.date, user.rno, user.amt, user.remark) }} className="icsank" />
                                            <UilTrash onClick={() => { deleteratibjma(user.sr) }} v className="icsank" />
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <ToastContainer />
        </div>
    )
}

export default Ratibjmasabh
